// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form_box div {\n  margin-bottom: 10px;\n}", "",{"version":3,"sources":["webpack://./src/app/private/modules/configuration/price-settings/price-settings.component.scss"],"names":[],"mappings":"AAEI;EAEI,mBAAA;AAFR","sourcesContent":[".form_box\r\n{\r\n    div\r\n    {\r\n        margin-bottom: 10px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
